/* Native collection filter dialog. GET submits remain Shopify storefront filters. */
(function () {
  if (window.minismusFiltersReady) return;
  window.minismusFiltersReady = true;
  var opener;

  function release(dialog) {
    if (dialog.open) dialog.close();
    document.documentElement.classList.remove('mnr-filter-open');
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      if (opener.isConnected) opener.focus({ preventScroll: true });
      opener = null;
    }
  }

  function prepare(root) {
    root.querySelectorAll('[data-mnr-filter-dialog]').forEach(function (dialog) {
      if (dialog.dataset.ready) return;
      dialog.dataset.ready = 'true';
      dialog.addEventListener('close', function () { release(dialog); });
      var backdropDown = false;
      dialog.addEventListener('pointerdown', function (event) { backdropDown = event.target === dialog; });
      dialog.addEventListener('click', function (event) {
        if (backdropDown && event.target === dialog) release(dialog);
        backdropDown = false;
      });
      var form = dialog.querySelector('form');
      // Blank bounds do not become a zero-price filter. Preserve repeated list values.
      form.addEventListener('formdata', function (event) {
        form.querySelectorAll('input[type="number"]').forEach(function (input) {
          if (!input.value) event.formData.delete(input.name);
        });
      });
      form.querySelectorAll('[data-mnr-price-range]').forEach(function (range) {
        var low = range.querySelector('[data-mnr-price-min]');
        var high = range.querySelector('[data-mnr-price-max]');
        var ceiling = low.max;
        function constrain() {
          low.max = high.value || ceiling;
          high.min = low.value || '0';
        }
        range.addEventListener('input', constrain);
        constrain();
      });
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-mnr-filter-open]');
    if (trigger) {
      var dialog = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!dialog) return;
      prepare(document);
      opener = trigger;
      trigger.setAttribute('aria-expanded', 'true');
      dialog.showModal();
      document.documentElement.classList.add('mnr-filter-open');
    }
    var close = event.target.closest('[data-mnr-filter-close]');
    if (close) release(close.closest('dialog'));
  });
  document.addEventListener('shopify:section:load', function (event) { prepare(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var dialog = event.target.querySelector('[data-mnr-filter-dialog][open]');
    if (dialog) release(dialog);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { prepare(document); });
  else prepare(document);
})();
